import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  const [menuActive, setMenuActive] = useState(false);
  const [progress, setProgress] = useState(0); // Progress state
  const [showScrollTop, setShowScrollTop] = useState(false); // New state for scroll to top button
  const navigate = useNavigate();
  const location = useLocation(); // useLocation hook to track route changes

  const headerlogoImages = [{ src: "/images/site-logo.png" }];

  // Toggle menu active state
  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  // Reset the menu and progress on route change, and scroll to top
  useEffect(() => {
    setMenuActive(false); // Close the menu
    setProgress(0); // Reset the progress bar

    // Scroll to top on every route change (including back/forward)
    // Timeout is added to ensure scroll happens after page paint
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "instant" }); // Ensure immediate scroll
    }, 0);
  }, [location.key]); // This ensures it triggers on route changes including back/forward

  const handleSearchChange = (e) => { };

  // Handle scroll event to update progress bar
  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrollPosition = window.scrollY;

      // Calculate scroll percentage
      const scrollPercentage = (scrollPosition / scrollHeight) * 100;
      setProgress(scrollPercentage); // Update progress bar based on scroll percentage

      // Show or hide scroll to top button
      setShowScrollTop(scrollPosition > 200); // Show button after 200px scroll
    };

    // Add event listener for scroll
    window.addEventListener("scroll", handleScroll);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Handle menu item click to reset the menu
  const handleMenuItemClick = () => {
    setMenuActive(false); // Close the menu when any item is clicked
  };

  // Scroll to top handler
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className="site-header">
      <div className="inner-content">
        <div className="bottom-bar">
          <div className="container">
            <div className="listing-header">
              {headerlogoImages.map((image, index) => (
                <div className="site-logo" key={index}>
                  <NavLink to="/">
                    <img src={image.src} alt="Technominds" />
                  </NavLink>
                </div>
              ))}
              <div className="site-nav">
                <div className="menu-toggle" onClick={toggleMenu}>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div className={`site-menu ${menuActive ? "active" : ""}`}>
                  <ul className="main-list">
                    <li>
                      <NavLink to="/">Home</NavLink>
                    </li>

                    <li>
                      <NavLink to="/commercial">Commercial</NavLink>
                    </li>
                    <li>
                      <NavLink to="/mold-inspections">Mold Inspections</NavLink>
                    </li>
                    <li>
                      <NavLink to="/mold-remediation">Mold Remediation</NavLink>
                    </li>
                    <li>
                      <NavLink to="/industerial-building">
                        Industrial Building
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/about-us">About Us</NavLink>
                    </li>

                    <li>
                      <NavLink to="./contact-us">Contact</NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll progress bar */}
      <div className="progress-container">
        <div
          className="progress-bar"
          style={{
            width: `${progress}%`,
            transition: "width 0.2s ease-in-out",
          }}
        ></div>
      </div>

      {/* Scroll To Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="scroll-to-top-btn bounce-animation"
        >
          <i className="fa-solid fa-arrow-up"></i>
        </button>
      )}
    </header>
  );
};

export default Header;
